import { Ba4020Class } from '../ba4020/ba4020-class';
import { Ba1301Class } from './ba1301-class';
import { Ba1302Class } from './ba1302-class';
import { Ba1303Class } from './ba1303-class';
import { Ba1304Class } from './ba1304-class';
import { Ba1305Class } from './ba1305-class';
import { Ba1306Class } from './ba1306-class';
import { Ba1307Class } from './ba1307-class';
import { Ba1308Class } from './ba1308-class';

export class Ba1300Class {
    EmpId:number;
    EmpNo:string;
    Salutation:string;
    FirstName:string;
    MiddleName:string;
    SurName:string;
    AliasName:string;
    FkCntryIdNationality:number;
    FkFieldIdGender:number;
    FkRlgnId:number;
    FkCasteId:number;
    PlaceOfBirth:string;
    DateOfBirth:Date;
    FkFieldIdMarital:number;
    FkFieldIdBloodGp:number;
    FkFieldIdMotherTounge:number;
    FkFieldIdFamilyStatus:number;
    FkEmpGrpId:number;
    FkApproveGrpId:number;
    FkEmpStatus:number;
    AddressC:string;
    FkCntryIdC:number;
    FkStateIdC:number;
    FkCityIdC  :number;
    ZipCodeC:string;
    PhoneC:string;
    MobileC:string;
    AddressP:string;    
    FkCntryIdP:number;
    FkStateIdP:number;
    FkCityIdP:number;
    ZipCodeP:string;
    PhoneP:string;
    MobileP:string;
    EmailP1:string;
    EmailP2:string;
    ContactPerson:string;
    AddressE:string;    
    FkCntryIdE:number;
    FkStateIdE:number;
    FkCityIdE:number;
    ZipCodeE:string;
    PhoneE:string;
    MobileE:string;
    EmailE1:string;
    EmailE2:string;
    FkFileIdPaymentMode:number;
    NationalId:string;
    NationalCardNo:string;
    NationalCardExpDate:Date;
    InsuranceNo:string;
    InsuranceClass:string;
    InsuranceStartDate:string;
    InsuranceEndDate:string;
    VisaUidNo:string;
    VisaNo:string;
    VisaPlaceOfIssue:string;
    VisaIssueDate:Date;
    VisaExpDate:Date;
    VisaSponsor:string;
    VisaProfession:string;
    LabourCardNo:string;
    LabourCardCode:string;
    LabourCardExpDate:Date;
    LabourCardProfession:string;
    LabourCardEstablishment:string;
    PassportName:string;
    PassportNo:string;
    PassportPlaceOfIssue:string;
    PassportIssueDate:Date;
    PassportExpDate:Date;
    Remarks:string;
    FkFileIdPhoto: number;
    FkFileIdSign: number;
    strEmp:string;
    FkLocationId:number;
    Active:number;
    StatusInsurance:number;
    // EmpImage:string;
    // EmpImageType:string;
    // EmpImageFileName:string;
    // SignImage:string;
    // SignImageType:string;
    // SignImageFileName:string;
    EmployeeName:string;
    Nationality:string;
    GenderFieldValue:string;
    LocationSelected: Array<Ba4020Class> = [];

    Ba1301List: Array<Ba1301Class> = [];
    Ba1302List: Array<Ba1302Class> = [];
    Ba1303List: Array<Ba1303Class> = [];
    Ba1304List: Array<Ba1304Class> = [];
    Ba1305List: Array<Ba1305Class> = [];
    Ba1306List: Array<Ba1306Class> = [];
    Ba1307List: Array<Ba1307Class> = [];
    Ba1308List: Array<Ba1308Class> = [];

    DeptDesc:string;
    DesgNam:string;
    PaygrpNam:string;
    SubDeptName:string;
    ValSelect:Boolean;

    photoURL: string;
    PhotoFileId : number;
    PhotoFileNameSelected : string;
    PhotoFileNameServer : string;
    PhotoFolder : string;
    PhotoFkPageId : number;
    PhotoPageName : string;
    PhotoTableName : string;
    PhotoAutoId : number;

    signURL: string;
    SignFileId : number;
    SignFileNameSelected : string;
    SignFileNameServer : string;
    SignFolder : string;
    SignFkPageId : number;
    SignPageName : string;
    SignTableName : string;
    SignAutoId : number;
    OtherDocId:number;
    CntryNam:string;
    CntryId:number;
    BiometricApplicable:number;
    BiometricMachineId:string;

    BuildingNoC:string;
    StreetC:string;
    PostalCodeC:string;
    DistrictC:string;
    SecondNoC  :string;
    SocialInsuranceNo:string;
    ReportingPersonFkEmpId:number;
    FieldId:number;
    FkAutoCodeDtlsId:number;
    CandidateId:number | null;
    FkCandidateId:number;
    LeaderId:number;

    FkEmpIdAssignedById:number;
    EmpIdAssignedToId:number;
    RptPersonCompId:number;

    MdfdBy: number;
    MdfdOn: Date;
    CrtdOn: Date;
 
    ba1300History: Ba1300Class;

    CandidateName:string;
    

}
